import type { InteractionMode } from '../../core/components/interactions-overlay/types.js';
import type { XYChartState } from '../types/state.js';

export function reduceInteractionMode(interactionMode: InteractionMode) {
  return (prev: XYChartState): XYChartState => ({ ...prev, interactionMode });
}
